/**
 * document.api.ts — Repositorio documental transversal (M12-3 backend, Fase C frontend).
 * Espejo de `aws-serverless/src/models/document.model.ts`.
 */

import { apiClient } from './client';

export type DocumentEntityType = 'SHIPMENT' | 'INVOICE' | 'MODULE' | 'PURCHASE_ORDER' | 'OTHER' | 'REPORT';

export interface DocumentItem {
  documentId: string;
  tenantId: string;
  entityKey: string;
  entityType: DocumentEntityType;
  entityId: string;
  docType: string;
  s3Key: string;
  version: number;
  generatedBy: string;
  createdAt: string;
}

/** Repositorio a nivel tenant — pantalla "Documentos" del portal (Fase C). */
export const fetchTenantDocuments = async (entityType?: DocumentEntityType, ranchoId?: string | null): Promise<DocumentItem[]> =>
  (await apiClient.get('/api/documents', {
    params: { ...(entityType ? { entityType } : {}), ...(ranchoId ? { ranchoId } : {}) },
  })).data.items ?? [];

export const fetchDocumentDownloadUrl = async (s3Key: string): Promise<string> =>
  (await apiClient.get('/api/documents/download-url', { params: { s3Key } })).data.url;
